// extracted by mini-css-extract-plugin
module.exports = {"locationDetails":"LocationDetails_locationDetails__2S6VQ"};